import React, { useCallback, useEffect, useRef, useState } from "react";
import ProfileNav from "../components/ProfileNav";
import toast from "react-hot-toast";
import {
  downloadDocument,
  handleProspects,
  prospectsDetails,
  uploadSla,
} from "../services/merchant";
import { useNavigate, useParams } from "react-router-dom";
import { useAuth } from "../context/AuthContextProvider";
import Spinner from "../components/Spinner";

const Review = () => {
  const [details, setDetails] = useState();
  const [errorMsg, setErrorMsg] = useState(false);
  const [comment, setComment] = useState("");
  const [terminalId, setTerminalId] = useState("");
  const [merchantId, setMerchantId] = useState("");
  const { id } = useParams();
  const { user, userrole } = useAuth();
  const navigate = useNavigate();
  const path = window.location.pathname;
  const [active, setActive] = useState(true);
  const [file, setFile] = useState(null);
  const [previewFile, setPreviewFile] = useState(null);
  const fileInputRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [loadDecline,setLoadDecline] = useState(false);

  const handleDocuChange = (e) => {
    const file = e.target.files[0];
    setFile(file);
    setActive(false);
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        setPreviewFile(reader.result); // Set the preview file data
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const formData = new FormData();
      formData.append("OnboardingId", details?.onboardingId);
      // formData.append("MerchantId", details?.merchantId);
      formData.append("File", file);

      const response = await uploadSla(formData);
      toast.success(response.message);
      console.log(response);
    } catch (error) {
      if (error.response) {
        toast.error(error.response.data.message);
      }
    }
  };

  const handleDocuClick = (e) => {
    fileInputRef.current.click();
  };

  const handleDecline = async (e, prospect) => {
    e.preventDefault();
    setLoadDecline(true);
    if (comment === "") {
      setErrorMsg("Please add a comment");
      return;
    }
    try {
      setErrorMsg("");
      const res = await handleProspects({
        approvedBy: user.firstName + " " + user.lastName,
        approved: false,
        approvalLevel: prospect.approvalLevel,
        comment,
        onboardingId: prospect.onboardingId,
        businessType: prospect.businessType,
        merchantId: merchantId,
        terminalId,
      });
      toast.success(res.message);
      setLoadDecline(false);
      if (path.includes("/prospects")) {
        navigate("/prospects");
      } else {
        navigate("/level-four-prospects");
      }
    } catch (error) {
      if (error.response) {
        setLoadDecline(false);
        toast.error(error.response.data.message);
      }
    }
  };

  const handleApprove = async (e, prospect) => {
    e.preventDefault();
    setLoading(true);
    if (userrole.role === "Business Support Maker" && merchantId === "") {
      setErrorMsg("Merchant id is required");
      return;
    }
    if (userrole.role === "Business Support Maker" && terminalId === "") {
      setErrorMsg("Terminal id is required");
      return;
    }
    try {
      setErrorMsg("");
      const res = await handleProspects({
        approvedBy: user.firstName + " " + user.lastName,
        approved: true,
        approvalLevel: prospect.approvalLevel,
        comment,
        onboardingId: prospect.onboardingId,
        businessType: prospect.businessType,
        merchantId: merchantId,
        terminalId,
      });
      toast.success(res.message);
      setLoading(false);
      if (path.includes("/prospects")) {
        navigate("/prospects");
      } else {
        navigate("/level-four-prospects");
      }
    } catch (error) {
      if (error.response) {
        setLoading(false);
        toast.error(error.response.data.message);
      }
    } 
  };

  const fetchProspects = useCallback(async () => {
    try {
      const res = await prospectsDetails(id);
      setDetails(res.data);
    } catch (error) {
      if (error.response) {
        toast.error(error.response.data.message);
      }
    }
  }, [id]);

  useEffect(() => {
    fetchProspects();
  }, [fetchProspects]);

  const retrieveKyc = async (file) => {
    try {
      const blobData = await downloadDocument(file.id);
      // Get the content type from the response headers
      const contentType = blobData.type;
      // Create a blob from the response data
      const blob = new Blob([blobData], { type: contentType });
      // Create a URL for the blob
      const url = window.URL.createObjectURL(blob);
      // Create a temporary <a> element
      const link = document.createElement("a");
      link.href = url;
      // Set the filename
      link.download = file?.fileName;
      // Simulate a click on the link to initiate the download
      link.click();
      // Cleanup
      window.URL.revokeObjectURL(url);
    } catch (error) {
      if (error.response) {
        toast.error(error.response.data.message);
      }
    }
  };

  const documentType = (name) => {
    if (name === "cac") {
      return "Certificate of Business Registration from the Corporate Affairs Commission";
    }
    if (name === "payment-license") {
      return "PSSP/PCIDSS";
    }
    if (name === "identity") {
      return "Means of identification for all Ultimate Beneficial Owners";
    }
    if (name === "sla") {
      return "SLA";
    }
  };

  return (
    <section className="w-[full] flex-grow-[6] pt-4 ">
      <div className="flex items-center justify-between mb-16">
        <h1 className="text-2xl font-bold text-navy-blue">Review Page</h1>
        <div>
          <ProfileNav />
        </div>
      </div>
      <div className="bg-white p-5 rounded-lg h-">
        <div className="flex items-center justify-between border rounded-t-lg shadow p-3">
          <span className="text-orange-400 text-[19px]">Review Page</span>
          <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M4.5 6.75L9 11.25L13.5 6.75"
              stroke="#464255"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
        <div className="p-3 text-[#444444]">
          <span className="font-medium text-[25px]">Business Information</span>
          <div className="p-4 w-[50%] flex flex-wrap justify-between gap-3">
            <section className="w-[45%]">
              <p className="font-medium">Business Name</p>
              <p>
                {details?.merchantName === null ? "N/A" : details?.merchantName}
              </p>
            </section>
            <section className="w-[45%]">
              <p className="font-medium">Business Account Number</p>
              <p>
                {details?.bankDetail?.accountNumber === null
                  ? "N/A"
                  : details?.bankDetail?.accountNumber}
              </p>
            </section>
            <section className="w-[45%]">
              <p className="font-medium">Business Email</p>
              <p>{details?.email === null ? "N/A" : details?.email}</p>
            </section>
            <section className="w-[45%]">
              <p className="font-medium">Business Bank Name</p>
              <p>
                {details?.bankDetail?.bankName === null
                  ? "N/A"
                  : details?.bankDetail?.bankName}
              </p>
            </section>
            <section className="w-[45%]">
              <p className="font-medium">Business Address</p>
              <p>{details?.address === null ? "N/A" : details?.address}</p>
            </section>
            <section className="w-[45%]">
              <p className="font-medium">Business Type</p>
              <p>
                {details?.businessType === "001"
                  ? "Generic Merchant"
                  : "Payment Facilitator"}
              </p>
            </section>
            <section className="w-[45%]">
              <p className="font-medium">Business Web Address/IP Address</p>
              <p>
                {details?.businessWebAddress === null
                  ? "N/A"
                  : details?.businessWebAddress}
              </p>
            </section>
            <section className="w-[45%]">
              <p className="font-medium">Country</p>
              <p>{details?.country === null ? "N/A" : details?.country}</p>
            </section>
            <section className="w-[45%]">
              <p className="font-medium">Business Phone Number</p>
              <p>
                {details?.phoneNumber === null ? "N/A" : details?.phoneNumber}
              </p>
            </section>
            <section className="w-[45%]">
              <p className="font-medium">Comment</p>
              <p>{details?.comment === null ? "N/A" : details?.comment}</p>
            </section>
            <section className="w-[45%]">
              <p className="font-medium">Merchant Id</p>
              <p>
                {details?.merchantId === null ? "N/A" : details?.merchantId}
              </p>
            </section>{" "}
            <section className="w-[45%]">
              <p className="font-medium">Terminal Id</p>
              <p>
                {details?.terminalId === null ? "N/A" : details?.terminalId}
              </p>
            </section>
          </div>
          <section className="p-4">
            {details?.documents?.map((file) => (
              <div className="flex justify-between border p-3 items-center">
                <span>
                  <p className="font-medium">{documentType(file?.key)}</p>
                  <p>{file.fileName}</p>
                </span>
                <button
                  className="text-orange-400 h-9 px-5 rounded-md border border-orange-400"
                  onClick={() => retrieveKyc(file)}
                >
                  Download
                </button>
              </div>
            ))}
          </section>
          <section className="p-4 flex justify-between">
            <div className="w-[40%] flex flex-col gap-2">
              <div
                className={`flex flex-col gap-2 ${userrole.role === "Business Support Maker"
                    ? "block"
                    : "hidden"
                  }`}
              >
                <label className="text-[18px]">Merchant ID</label>
                <input
                  className="outline-none bg-gray-200 p-3 rounded-md"
                  placeholder="Enter Merchant ID"
                  type="text"
                  onChange={(e) => setMerchantId(e.target.value)}
                />
              </div>
              <div
                className={`flex flex-col gap-2 ${userrole.role === "Business Support Maker"
                    ? "block"
                    : "hidden"
                  }`}
              >
                <label className="text-[18px]">Terminal ID</label>
                <input
                  className="outline-none bg-gray-200 p-3 rounded-md"
                  placeholder="Enter Terminal ID"
                  type="text"
                  onChange={(e) => setTerminalId(e.target.value)}
                />
              </div>
              <div className="flex flex-col gap-2">
                <label htmlFor="comment" className="text-[18px]">
                  Comment
                </label>
                <textarea
                  name="comment"
                  placeholder="Leave a comment.."
                  onChange={(e) => setComment(e.target.value)}
                  className="h-[150px] bg-gray-100 outline-none pt-7 px-2 rounded-[.5rem] pl-[.5rem] mt-3"
                />
              </div>
              {errorMsg && <p className="text-red-500">{errorMsg}</p>}
            </div>

            <form
              onSubmit={handleSubmit}
              className="w-[60%] flex flex-col items-center"
            >
              <div
                className={`${userrole.role === "Business Support Maker"
                    ? "flex flex-col items-center"
                    : "hidden"
                  }`}
              >
                <p className="font-medium text-xl">Upload SLA </p>
                <p className="text-gray-400">
                  Upload fully executed Service Legal Agreement here{" "}
                </p>
                <div className="border-2 border-dashed mt-3 flex items-center justify-between w-[80%] p-3 rounded-lg">
                  {previewFile ? (
                    <div className="flex flex-col items-center">
                      {file.type.startsWith("image/") ? (
                        <img
                          src={previewFile}
                          alt="Preview"
                          className="max-w-[180px] max-h-[180px]"
                        />
                      ) : (
                        <div className="text-gray-400 flex ">{file.name}</div>
                      )}
                    </div>
                  ) : (
                    <>
                      <svg
                        width="48"
                        height="48"
                        viewBox="0 0 48 48"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M32 32L24 24L16 32"
                          stroke="black"
                          stroke-opacity="0.4"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M24 24V42"
                          stroke="black"
                          stroke-opacity="0.4"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M40.78 36.78C42.7307 35.7165 44.2717 34.0337 45.1598 31.9972C46.0478 29.9607 46.2324 27.6864 45.6844 25.5334C45.1364 23.3803 43.887 21.471 42.1334 20.1069C40.3797 18.7427 38.2217 18.0014 36 18H33.48C32.8746 15.6585 31.7463 13.4846 30.1799 11.642C28.6135 9.79927 26.6497 8.33567 24.4362 7.36118C22.2227 6.3867 19.8171 5.92669 17.4002 6.01573C14.9834 6.10478 12.6181 6.74057 10.4824 7.8753C8.34658 9.01003 6.49583 10.6142 5.06926 12.5671C3.64268 14.5201 2.67739 16.771 2.24597 19.1508C1.81455 21.5305 1.92822 23.977 2.57844 26.3065C3.22865 28.636 4.3985 30.7877 6.00001 32.6"
                          stroke="black"
                          stroke-opacity="0.4"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M32 32L24 24L16 32"
                          stroke="black"
                          stroke-opacity="0.4"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      <span>
                        <p className="font-medium">
                          Select a File of drag and drop here
                        </p>
                        <p className="text-gray-400">
                          JPG, PNG OR PDF, file size no more than 10MB{" "}
                        </p>
                      </span>
                    </>
                  )}

                  <input
                    type="file"
                    id="upload"
                    name="upload"
                    accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                    className="hidden"
                    ref={fileInputRef}
                    onChange={handleDocuChange}
                  />
                  <button
                    onClick={handleDocuClick}
                    className="text-orange-400 text-1xl p-2 rounded-md border border-blue-900"
                  >
                    SELECT FILE
                  </button>
                </div>

                <div className="flex p-3 w-[80%] justify-between">
                  <button
                    type="button"
                    disabled={active}
                    className="text-orange-400 cursor-pointer"
                    onClick={handleSubmit}
                  >
                    Upload Document
                  </button>
                  {/* <span className="flex items-center gap-3">
                  <svg
                    width="18"
                    height="24"
                    viewBox="0 0 18 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M6.75299 10.5C7.04847 10.5 7.34105 10.4418 7.61403 10.3287C7.88701 10.2157 8.13505 10.0499 8.34398 9.84099C8.55291 9.63206 8.71865 9.38402 8.83172 9.11104C8.94479 8.83806 9.00299 8.54547 9.00299 8.25C9.00299 7.95453 8.94479 7.66194 8.83172 7.38896C8.71865 7.11598 8.55291 6.86794 8.34398 6.65901C8.13505 6.45008 7.88701 6.28434 7.61403 6.17127C7.34105 6.0582 7.04847 6 6.75299 6C6.15625 6 5.58396 6.23705 5.162 6.65901C4.74004 7.08097 4.50299 7.65326 4.50299 8.25C4.50299 8.84674 4.74004 9.41903 5.162 9.84099C5.58396 10.2629 6.15625 10.5 6.75299 10.5Z"
                      fill="#F58220"
                    />
                    <path
                      d="M18 21C18 21.7956 17.6839 22.5587 17.1213 23.1213C16.5587 23.6839 15.7956 24 15 24H3C2.20435 24 1.44129 23.6839 0.87868 23.1213C0.31607 22.5587 0 21.7956 0 21V3C0 2.20435 0.31607 1.44129 0.87868 0.87868C1.44129 0.316071 2.20435 0 3 0L11.25 0L18 6.75V21ZM3 1.5C2.60218 1.5 2.22064 1.65804 1.93934 1.93934C1.65804 2.22064 1.5 2.60218 1.5 3V18L4.836 14.664C4.95422 14.5461 5.10843 14.4709 5.27417 14.4506C5.43992 14.4302 5.60773 14.4657 5.751 14.5515L9 16.5L12.2355 11.97C12.2988 11.8815 12.3806 11.8078 12.4753 11.754C12.5699 11.7003 12.6751 11.6678 12.7836 11.6588C12.8921 11.6498 13.0012 11.6645 13.1034 11.702C13.2056 11.7394 13.2985 11.7986 13.3755 11.8755L16.5 15V6.75H13.5C12.9033 6.75 12.331 6.51295 11.909 6.09099C11.4871 5.66903 11.25 5.09674 11.25 4.5V1.5H3Z"
                      fill="#F58220"
                    />
                  </svg>
                  <p>Service Legal Arrangement.jpeg</p>
                  <p className="flex justify-center font-medium text-xl">.</p>
                  <p className="text-orange-400">Preview</p>
                </span>
                <span>2.7MB</span> */}
                </div>
              </div>
              <div
                className={`w-[65%] flex justify-between ${userrole.role === "Business Support Maker" ? "" : "mt-20"
                  }`}
              >
                <button
                  className="w-[30%] border border-orange-400 p-2 rounded-md text-orange-400"
                  type="button"
                  onClick={(e) => handleDecline(e, details)}
                >
                  {loadDecline ? <Spinner /> : "Decline"}
                </button>
                <button
                  className="w-[60%] bg-orange-400 p-2 rounded-md text-white"
                  onClick={(e) => handleApprove(e, details)}
                >
                  {loading ? <Spinner /> : "Approve"}
                </button>
              </div>
            </form>
          </section>
        </div>
      </div>
    </section>
  );
};

export default Review;
